import React, { FunctionComponent } from 'react';

import * as S from './ThreeRowsLayout.styles';

export interface ThreeRowsLayoutProps {
  leftSideContent: React.ReactNode;
  rightSideContent: React.ReactNode;
}

const defaultProps: Partial<ThreeRowsLayoutProps> = {};

const ThreeRowsLayout: FunctionComponent<ThreeRowsLayoutProps> = ({
  leftSideContent,
  rightSideContent,
  ...rest
}) => {
  return (
    <S.Wrapper {...rest}>
      {leftSideContent}
      <S.RightSide>{rightSideContent}</S.RightSide>
    </S.Wrapper>
  );
};

ThreeRowsLayout.defaultProps = defaultProps;

export default ThreeRowsLayout;
